import { render, staticRenderFns } from "./expediente.vue?vue&type=template&id=dd34d886"
import script from "./expediente.vue?vue&type=script&lang=js"
export * from "./expediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports